import { useId } from "react";
import { useNavigate } from "react-router-dom";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import SolarGikButton from "../../SolarGikLib/Button";
import { filledBlueButton } from "../../SolarGikLib/styles/ButtonsStyle";
import { MultiSitePage } from "../../pages/PageNames";
import classes from "./SitePageNotice.module.css";

interface SitePageNoticeProps {
  title: string;
  message: string;
  fullPage?: boolean;
}

export default function SitePageNotice({ title, message, fullPage = false }: SitePageNoticeProps) {
  const titleId = useId();
  const navigate = useNavigate();
  return (
    <section
      className={`${classes.content} ${fullPage ? classes.fullPage : ""}`}
      aria-labelledby={titleId}
    >
      <InfoOutlined className={classes.icon} aria-hidden="true" />
      <h1 id={titleId} className={classes.title}>
        {title}
      </h1>
      <p className={classes.message}>{message}</p>
      {fullPage && (
        <SolarGikButton
          text="Go home"
          style={filledBlueButton}
          onClickFunc={() => navigate(`/${MultiSitePage.Multisite}`)}
        />
      )}
    </section>
  );
}
